import { profileRoutes } from "./profile-routes";

export default (router: any) => {
  profileRoutes.forEach((route: any) => {
    router.addRoute(route);
  });
};
